import shopifyGenericDefaults from '../shopify-generic/config.js';
const wheelsFields = ['wheel_tire_diameter', 'wheel_width', 'wheel_bolt_pattern'];
const tiresFields = ['tire_width', 'tire_aspect', 'wheel_tire_diameter'];
const ignoreFields = [...new Set([...wheelsFields, ...tiresFields])];
export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  fitmentSearch: {
    ...shopifyGenericDefaults.fitmentSearch,
    categorySelectionPageRedirect: true,
    isVehicleSelectionIsolated: true,
  },
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter(
      (w) =>
        ![
          'FacetBarWheels',
          'FacetBarTires',
          'FilterChips',
          'Facets',
          'WheelPanel_tab',
          'TirePanel_tab',
        ].includes(w.name),
    ),
    {
      name: 'WheelTireVehicleInfo',
      useAutoSyncVisualizer: true,
    },
    {
      name: 'UpsizeDownsizeFacetPanel',
      type: 'FacetPanel',
      fields: ['wheel_tire_diameter'],
      showAllAlways: true,
      disableCollapse: true,
    },
    {
      name: 'AutoSyncVisualization',
      config: {
        height: '150px',
        vehicleImageSize: 640,
        vehicleAngles: [32],
        showColorPicker: false,
      },
      classModificator: 'search-result',
    },
    {
      ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'WheelPanel_tab'),
      selectFields: wheelsFields,
    },
    {
      ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'TirePanel_tab'),
      selectFields: tiresFields,
    },

    {
      name: 'FacetBarWheels',
      type: 'FacetBar',
      fields: wheelsFields,
      minFacetCount: 2,
    },
    {
      name: 'FacetBarTires',
      type: 'FacetBar',
      fields: tiresFields,
      minFacetCount: 2,
    },
    {
      name: 'FilterChips',
      type: 'FacetPanel',
      ignoreFields,
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
      ignoreFields,
    },
  ],
};
